import { ReactComponent as PlasticSignIcon } from "./plastic_sign.svg"
import { ReactComponent as ForexSignIcon } from "./forex_sign.svg"
import { ReactComponent as NameSignIcon } from "./name_sign.svg"
import { ReactComponent as ColorBadgeIcon } from "./color_badge.svg"
import { ReactComponent as WoodSignIcon } from "./wood_sign.svg"
import { ReactComponent as AluminiumSignIcon } from "./aluminium_sign.svg"
import { ReactComponent as AcrylSignIcon } from "./acryl_sign.svg"
import { ReactComponent as VinylTextIcon } from "./vinyl_text.svg"
import { ReactComponent as StickerIcon } from "./sticker.svg"
import { ReactComponent as PosterIcon } from "./poster.svg"
import { ReactComponent as BannerIcon } from "./banner.svg"
import { ReactComponent as BrassSignIcon } from "./brass_sign.svg"
import { ReactComponent as RollupIcon } from "./rollup.svg"
import { ReactComponent as MagneticSignIcon } from "./magnetic_sign.svg"
import { ReactComponent as label_plates } from "./label_plates.svg"
import { ReactComponent as double_sided_sign } from "./double_sided_sign.svg"
import { ReactComponent as contour_cut } from "./contour_cut.svg"
import { ReactComponent as ecoboard } from "./ecoboard.svg"
import { ReactComponent as HygieneScreenIcon } from "./hygiene_screen.svg"
import { ReactComponent as door_sign } from "./door_sign.svg"
import { ReactComponent as house_sign } from "./house_sign.svg"
import { ReactComponent as acryl_alu_sign } from "./acryl_alu_sign.svg"
import { ReactComponent as stainless_steel_sign } from "./stainless_steel_sign.svg"
import { ReactComponent as tactile_sign } from "./tactile_sign.svg"

const icons: IconMap = {
  meta_plastic_sign: PlasticSignIcon,
  plastic_sign: PlasticSignIcon,
  forex_sign: ForexSignIcon,
  meta_name_sign: NameSignIcon,
  name_sign: NameSignIcon,
  color_badge: ColorBadgeIcon,
  wood_sign: WoodSignIcon,
  aluminium_sign: AluminiumSignIcon,
  acryl_sign: AcrylSignIcon,
  vinyl_text: VinylTextIcon,
  sticker: StickerIcon,
  poster: PosterIcon,
  banner: BannerIcon,
  brass_sign: BrassSignIcon,
  rollup: RollupIcon,
  magnetic_sign: MagneticSignIcon,
  hygiene_screen: HygieneScreenIcon,
  label_plates,
  double_sided_sign,
  contour_cut,
  ecoboard,
  door_sign,
  house_sign,
  acryl_alu_sign,
  stainless_steel_sign,
  tactile_sign,
}

export default icons
